import { Stack } from 'expo-router';

import { primitive } from 'styles/constants';
import { isWeb } from 'utils/environment';

export default function DrawerLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen
        name="account/index"
        options={{
          contentStyle: { backgroundColor: 'transparent' },
          animation: 'none',
          ...(isWeb && {
            presentation: 'transparentModal',
          }),
        }}
      />
    </Stack>
  );
}
